import moment from 'moment';
import {toastr} from 'react-redux-toastr';
import {initialize} from 'redux-form';
import {
  setSquadCapacity,
  displaySquads,
  displayCapacityDialog,
  hideCapacityDialog,
  displayEventsInDropDown,
  setSquadVisibility
} from './actionTypes';
import {
  getJsonAsync,
  postJsonAsync,
  putJsonAsync
} from 'shared/actions';
import {validateDate} from 'shared/validators';

export const retrieveSquadsByTournament = tournamentId => dispatch => {
  dispatch(displaySquads(null));
  dispatch(getJsonAsync(`tournament/${tournamentId}/squads/capacity`))
    .then(data => dispatch(displaySquads(data)));
};

export const handleUpdateButtonClick = () => (dispatch, getState) => {
  const {
    id: tournamentId,
    startDate,
    endDate
  } = getState().tournament.base.tournamentInfo;

  dispatch(getJsonAsync(`tournament/${tournamentId}/events/`))
    .then(data => {
      dispatch(displayEventsInDropDown(data.map(({id, name}) => ({
        value: id,
        label: name
      }))));

      dispatch(displayCapacityDialog(`Update Availability`));
      dispatch(initialize(`capacityAvailabilityForm`, {
        startDate: moment(startDate).format('YYYY-MM-DD'),
        endDate: moment(endDate).format('YYYY-MM-DD')
      }));
    });
};

export const handleCapacitySave = data => (dispatch, getState) => new Promise((resolve) => {

  // scrub times from datepicker values
  data.startDate = moment(data.startDate).format('YYYY-MM-DD');
  data.endDate = moment(data.endDate).format('YYYY-MM-DD');

  dispatch(postJsonAsync(`capacity`, data))
  .then(() => {
    const tournamentId = getState().tournament.base.tournamentInfo.id;

    toastr.success('Saved!', 'Squad capacity was successfully saved.');
    dispatch(hideCapacityDialog());
    dispatch(retrieveSquadsByTournament(tournamentId));
    resolve();
  })
  .catch(() => resolve());
});

export const handleUpdateSquadCapacity = data => dispatch => {
  if(data.dirty) {
    dispatch(postJsonAsync(`capacity/${data.squadId}`, data.inputValue))
    .then(() => {
      dispatch(setSquadCapacity(data.squadId, data.inputValue));
      toastr.success('Saved!', 'Squad capacity was successfully saved.');
    })
    .catch(() => {});
  }
};

export const handleUpdateSquadVisibility = (id, value) => dispatch => {
  dispatch(putJsonAsync(`squad/${id}/hideFromCaptains`, {squadId: id, hideFromCaptains: value}))
  .then(() => {
    dispatch(setSquadVisibility(id, value));
    toastr.success('Saved!', 'Squad visibility was successfully updated.');
  })
  .catch(() => {});
};

export const validate = (data) => {
  const errors = {};

  if(!data.capacity && data.capacity !== 0) {
    errors.capacity = 'Capacity is required';
  } else if (data.capacity < 0){
    errors.capacity = 'Capacity must be greater than zero';
  } else if (data.capacity > 100){
    errors.capacity = 'Capacity must be less than one hundred';
  }

  if (!data.eventId) {
    errors.eventId = 'Event must specified.';
  }

  if(!data.startDate || !validateDate(data.startDate)) {
    errors.startDate = 'We need to be able to set a start date';
  }

  if(!data.endDate || !validateDate(data.endDate)) {
    errors.endDate = 'We need to be able to set an end date';
  }

  if(data.startDate && data.endDate && data.startDate > data.endDate) {
    errors.startDate = 'Start date must be less or equals to end date';
    errors.endDate = 'End date must be greater than start date';
  }

  return errors;
};



// WEBPACK FOOTER //
// ./src/features/tournament/capacity/actions.js